// Product Tabs functionality
class ProductTabs {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('.product-tabs__tab');
    this.panels = container.querySelectorAll('.product-tabs__panel');
    
    this.init();
  }
  
  init() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', (e) => this.switchTab(e.currentTarget));
    });
  }
  
  switchTab(clickedTab) {
    const targetPanel = clickedTab.dataset.tab;
    
    // Remove active class from all tabs and panels
    this.tabs.forEach(tab => tab.classList.remove('active'));
    this.panels.forEach(panel => panel.classList.remove('active'));
    
    // Add active class to clicked tab
    clickedTab.classList.add('active');
    
    // Show corresponding panel
    const activePanel = this.container.querySelector(`[data-panel="${targetPanel}"]`);
    if (activePanel) {
      activePanel.classList.add('active');
    }
  }
}

// Initialize tabs on page load
document.addEventListener('DOMContentLoaded', () => {
  const tabContainers = document.querySelectorAll('.product-tabs');
  tabContainers.forEach(container => new ProductTabs(container));
});

// Re-initialize when section is reloaded in theme editor
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('.product-tabs');
    if (container) {
      new ProductTabs(container);
    }
  });
}

